// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LU5vj","question":"styles_question__FHkX9","description":"styles_description__2HIej"};